import React from "react";
import { AuthProvider } from "./auth.context";

const ContextProvider = ({ children }) => (
  <AuthProvider>{children}</AuthProvider>
);

export default ContextProvider;
